import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = import.meta.env.VITE_SITE_NAME || 'Cripto News';

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Página não encontrada | {SITE_NAME}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center px-4 max-w-md">
          <div className="text-8xl font-bold text-blue-600 mb-4">404</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Página não encontrada</h1>
          <p className="text-gray-600 mb-8">
            Ops! A página que você procura não existe ou foi movida.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Ir para a Home
            </Link>
            <Link
              to="/glossario"
              className="bg-white text-blue-600 font-semibold px-6 py-3 rounded-lg border border-blue-600 hover:bg-blue-50 transition"
            >
              Ver Glossário
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
